export const IconTrash = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="30px"
    height="30px"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#f80d0d"
      stroke="none"
    >
      <path
        d="M443 1265 c-36 -15 -63 -60 -63 -105 l0 -30 -124 0 c-110 0 -126 -2
-150 -21 -19 -15 -26 -30 -26 -54 0 -24 7 -39 26 -54 26 -21 36 -21 534 -21
498 0 508 0 534 21 36 28 36 80 0 108 -24 19 -40 21 -150 21 l-124 0 0 35 c0
43 -23 81 -61 101 -39 20 -350 20 -396 -1z m375 -77 c7 -7 12 -22 12 -35 l0
-23 -190 0 -190 0 0 23 c0 13 5 28 12 35 17 17 339 17 356 0z"
      />
      <path
        d="M160 883 c0 -16 14 -199 31 -408 21 -253 36 -391 46 -412 28 -60 45
-63 403 -63 358 0 375 3 403 63 10 21 25 159 46 412 17 209 31 392 31 408 l0
27 -480 0 -480 0 0 -27z m279 -67 c8 -9 20 -128 32 -327 18 -273 18 -314 6
-327 -23 -22 -55 -6 -61 31 -3 18 -13 161 -22 319 -14 232 -14 290 -4 303 16
19 34 19 49 1z m231 -5 c14 -27 14 -615 0 -642 -14 -25 -46 -25 -60 0 -14 27
-14 615 0 642 6 10 19 19 30 19 11 0 24 -9 30 -19z m220 4 c10 -13 10 -71 -4
-303 -9 -158 -19 -301 -22 -319 -6 -37 -38 -53 -61 -31 -12 13 -12 54 6 327
12 199 24 318 32 327 15 18 33 18 49 -1z"
      />
    </g>
  </svg>
);
